import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'brand_leads-inbound_brand_apply_redirect-action_unknown';

/**
 * Triggered when the brand is redirected after filling out the form on the apply page
 */
export function trackBrandLeadsInboundBrandApplyRedirect(
  application_stage: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { application_stage },
  });
}
